(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["luli-product-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('luli-product-tabs')) {
    class LuliProductTabs extends HTMLElement {
      connectedCallback() {
        this.groupTabs = Array.from(this.querySelectorAll('[data-level="group"] [role="tab"]'));
        this.styleList = this.querySelector('[data-level="style"]');
        this.styleTabs = this.styleList ? Array.from(this.styleList.querySelectorAll('[role="tab"]')) : [];
        this.subLists = Array.from(this.querySelectorAll('[data-level="sub"]'));
        this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
        this.shown = this.panels.find((panel) => !panel.hidden) || this.panels[0];
        if (!this.shown) return;

        this.activeGroup = this.shown.dataset.group;
        const selectedStyle = this.styleTabs.find((tab) => tab.getAttribute('aria-selected') === 'true');
        this.activeStyle = selectedStyle ? selectedStyle.dataset.style : '1';
        // Subgrupo escolhido em cada grupo (vale enquanto existir no estilo; senão cai no primeiro disponível)
        this.preferredSub = {};

        // "Ver todos" do cabeçalho passa a abrir a coleção já filtrada pela combinação ativa
        const section = this.closest('.section-resource-list');
        const collectionUrl = this.dataset.collectionUrl;
        this.viewAllLinks =
          section && collectionUrl
            ? Array.from(section.querySelectorAll('.section-resource-list__header a[href]')).filter(
                (link) => new URL(link.href, window.location.origin).pathname === collectionUrl
              )
            : [];

        this.addEventListener('click', (event) => {
          const tab = event.target.closest('[role="tab"]');
          if (tab && this.contains(tab)) this.select(tab);
        });
        this.addEventListener('keydown', (event) => this.onKeydown(event));

        // Pré-carrega a combinação de uma aba assim que o dedo/mouse chega nela
        const prefetch = (event) => {
          const tab = event.target.closest?.('[role="tab"]');
          if (tab && this.contains(tab)) this.load(this.panelForTab(tab));
        };
        this.addEventListener('pointerover', prefetch, { passive: true });
        this.addEventListener('touchstart', prefetch, { passive: true });
        this.addEventListener('focusin', prefetch);

        this.render();
      }

      select(tab) {
        if (tab.dataset.group) this.activeGroup = tab.dataset.group;
        if (tab.dataset.style) this.activeStyle = tab.dataset.style;
        if (tab.dataset.sub) this.preferredSub[this.activeGroup] = tab.dataset.sub;
        this.render();
        this.scrollTabIntoView(tab);
      }

      onKeydown(event) {
        const lists = [this.groupTabs, this.styleTabs, ...this.subLists.map((list) => this.visibleTabs(list))];
        const tabs = lists.find((list) => list.includes(document.activeElement));
        if (!tabs) return;
        const current = tabs.indexOf(document.activeElement);
        let next = null;
        if (event.key === 'ArrowRight') next = (current + 1) % tabs.length;
        else if (event.key === 'ArrowLeft') next = (current - 1 + tabs.length) % tabs.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = tabs.length - 1;
        if (next === null) return;
        event.preventDefault();
        this.select(tabs[next]);
        tabs[next].focus({ preventScroll: true });
      }

      visibleTabs(list) {
        return Array.from(list.querySelectorAll('[role="tab"]')).filter((tab) => !tab.hidden);
      }

      // Painel de uma combinação. Grupo sem estilo usa style "0"; sem o subgrupo pedido, o primeiro (maior) disponível
      resolve(group, style, sub) {
        const inGroup = this.panels.filter((panel) => panel.dataset.group === group);
        const hasStyles = inGroup.some((panel) => panel.dataset.style !== '0');
        const inStyle = inGroup.filter((panel) => panel.dataset.style === (hasStyles ? style : '0'));
        return inStyle.find((panel) => panel.dataset.sub === sub) || inStyle[0] || inGroup[0];
      }

      panelForTab(tab) {
        const group = tab.dataset.group || this.activeGroup;
        const style = tab.dataset.style || this.activeStyle;
        const sub = tab.dataset.sub || this.preferredSub[group];
        return this.resolve(group, style, sub);
      }

      // Busca a grade da combinação no template alternativo da coleção (uma vez só por painel)
      load(panel) {
        if (!panel || panel.dataset.loaded === 'true') return Promise.resolve();
        if (!panel.dataset.viewAll) {
          panel.dataset.loaded = 'true';
          return Promise.resolve();
        }
        if (panel.loading) return panel.loading;

        const url = new URL(panel.dataset.viewAll, window.location.origin);
        url.searchParams.set('view', 'luli-vitrine');
        panel.loading = fetch(url)
          .then((response) => {
            if (!response.ok) throw new Error(`HTTP ${response.status}`);
            return response.text();
          })
          .then((html) => {
            const content = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-luli-panel]');
            if (!content) throw new Error('painel não encontrado');
            panel.innerHTML = content.innerHTML;
          })
          .catch(() => {
            panel.innerHTML = '';
            const message = document.createElement('p');
            message.className = 'luli-ptabs__empty';
            const link = document.createElement('a');
            link.href = panel.dataset.viewAll;
            link.textContent = 'Ver os produtos';
            message.append('Não foi possível carregar agora. ', link);
            panel.append(message);
          })
          .finally(() => {
            panel.dataset.loaded = 'true';
            panel.loading = null;
          });
        return panel.loading;
      }

      // No celular as linhas rolam de lado: traz a aba escolhida pra dentro da tela
      scrollTabIntoView(tab) {
        const list = tab.parentElement;
        if (!list || list.scrollWidth <= list.clientWidth) return;
        const listRect = list.getBoundingClientRect();
        const tabRect = tab.getBoundingClientRect();
        if (tabRect.left < listRect.left) {
          list.scrollBy({ left: tabRect.left - listRect.left - 16, behavior: 'smooth' });
        } else if (tabRect.right > listRect.right) {
          list.scrollBy({ left: tabRect.right - listRect.right + 16, behavior: 'smooth' });
        }
      }

      render() {
        const group = this.activeGroup;
        const active = this.resolve(group, this.activeStyle, this.preferredSub[group]);
        if (!active) return;
        const groupHasStyles = active.dataset.style !== '0';

        this.groupTabs.forEach((tab) => {
          const isSelected = tab.dataset.group === group;
          tab.setAttribute('aria-selected', String(isSelected));
          tab.tabIndex = isSelected ? 0 : -1;
          tab.setAttribute('aria-controls', this.panelForTab(tab)?.id || '');
        });

        if (this.styleList) this.styleList.hidden = !groupHasStyles;
        this.styleTabs.forEach((tab) => {
          const isSelected = tab.dataset.style === this.activeStyle;
          tab.setAttribute('aria-selected', String(isSelected));
          tab.tabIndex = isSelected ? 0 : -1;
          tab.setAttribute('aria-controls', this.panelForTab(tab)?.id || '');
        });

        // Linha de subgrupos só do grupo ativo, e só com os subgrupos que têm produto no estilo ativo
        this.subLists.forEach((list) => {
          const isActiveGroup = list.dataset.group === group;
          list.hidden = !isActiveGroup;
          if (!isActiveGroup) return;
          let visible = 0;
          list.querySelectorAll('[role="tab"]').forEach((tab) => {
            const target = this.panels.find(
              (panel) =>
                panel.dataset.group === group &&
                panel.dataset.style === active.dataset.style &&
                panel.dataset.sub === tab.dataset.sub
            );
            tab.hidden = !target;
            if (target) visible += 1;
            const isSelected = target === active;
            tab.setAttribute('aria-selected', String(isSelected));
            tab.tabIndex = isSelected ? 0 : -1;
            tab.setAttribute('aria-controls', target?.id || '');
          });
          if (visible === 0) list.hidden = true;
        });

        if (active.dataset.viewAll) {
          this.viewAllLinks.forEach((link) => {
            link.href = active.dataset.viewAll;
          });
        }

        if (active.dataset.loaded !== 'true') {
          // Mantém a grade atual esmaecida até a nova chegar; o render seguinte troca (se a escolha ainda for essa)
          if (this.shown && this.shown !== active) this.shown.classList.add('is-loading');
          this.setAttribute('aria-busy', 'true');
          this.load(active).then(() => this.render());
          return;
        }

        this.removeAttribute('aria-busy');
        this.panels.forEach((panel) => {
          panel.hidden = panel !== active;
          panel.classList.remove('is-loading');
        });
        this.shown = active;
      }
    }

    customElements.define('luli-product-tabs', LuliProductTabs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
